export default __webpack_public_path__ + "static/Stefan-de19b1e478619bbd15b3d1217e9a6cf3.jpg";